export default function (context) {
    context.redirect('/Orders/Orders')
}
